"use strict";

exports.__esModule = true;
exports.default = void 0;
var _orbitDesignTokens = require("@kiwicom/orbit-design-tokens");
exports.default = _orbitDesignTokens.fromPlainObject;